/*eslint-env jquery*/
import React, { Component } from 'react'
// import ReactTestUtils, { ReactDOM } from 'react-dom'
// import PropTypes from 'prop-types'
import moment from 'moment-jalaali' // Notice here !
import { DatetimePickerTrigger } from 'imrc-datetime-picker'
import MaskedInput from 'react-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
// import Loading from '../Shared/Loading'

moment.loadPersian({
  dialect: 'persian-modern',
  usePersianDigits: false
})

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy/mm/dd')

class DatePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      _moment: moment(),
      defaultValue: this.props.defaultValue,
      cleared: true,
      loading: true
      // value: this.props.defaultValue ?
      //   this.formatDefaultValue(this.props.defaultValue) : ''
    }

    // console.log("here0")
  }

  async componentWillReceiveProps(nextProps) {
    // console.log("here1")
    if (nextProps.defaultValue && moment(nextProps.defaultValue).isValid()) {
      // console.log("here2")
      await this.formatDefaultValue(nextProps.defaultValue)
    }
  }

  formatDefaultValue = async e => {
    if (e !== '0001-01-01T00:00:00') {
      let m = moment(e.split('T')[0], 'YYYY-MM-DD')
      const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
      if (momentValue.isValid()) {
        await this.setState({
          inputValue: momentValue.format('jYYYY/jMM/jDD'),
          _moment: m,
          loading: false,
          cleared: false
        })
      }
    }
  }

  handleChange = selectedMoment => {
    const inputValue = selectedMoment
    const momentValue = inputValue.format('jYYYY/jMM/jDD')

    this.setState({
      inputValue: momentValue,
      _moment: selectedMoment,
      cleared: false
    })

    const val = selectedMoment.format('YYYY-MM-DD')
    this.props.onChange(val)

    // if (moment(val, "YYYY-MM-DD").isValid()) {
    //   // console.log(val);
    //   this.dispatchEventChange(inputValue);
    // }
  }

  dispatchEventChange = val => {
    var element = this.node
    var ev = new Event('input', { bubbles: true })
    ev.simulated = true
    element.value = val
    element.dispatchEvent(ev)
  }

  handleInputChange = event => {
    var inputValue = ''
    inputValue = event.target.value

    if (inputValue.replace('_', '').length === 10) {
      const momentValue = moment(inputValue, 'jYYYY-jMM-jDD')

      this.setState({ inputValue, cleared: true })

      if (momentValue.isValid()) {
        this.setState({ _moment: momentValue, cleared: false })

        const val = momentValue.format('YYYY-MM-DD')
        // console.log(val);

        if (val) {
        }
        this.props.onChange(val)

        // console.log(inputValue);
        // this.dispatchEventChange(momentValue);
      } else {
        var tmp = inputValue.slice(0, -1)
        this.setState({ inputValue: tmp })
        this.props.onChange(undefined)
      }
    } else {
      // if (this.props.defaultValue) {
      this.props.onChange('')
      // this.setState({inputValue: undefined})
      // }
    }
  }

  render() {
    const { _moment, cleared, inputValue } = this.state

    const {
      name,
      onChange,
      handleBlur,
      disabled,
      minDate,
      maxDate,
      required
    } = this.props

    const newMoment = moment()

    // var value = !cleared && _moment ? _moment.format("jYYYY/jMM/jDD") : "";

    return (
      <div className={required ? 'required datepicker' : 'datepicker'}>
        <DatetimePickerTrigger
          disabled={disabled}
          moment={_moment}
          onChange={this.handleChange}
          isSolar={true}
          lang={'fa'}
          showTimePicker={false}
          closeOnSelectDay={true}
          minDate={minDate}
          maxDate={maxDate}>
          <MaskedInput
            disabled={disabled}
            className="date-input dateFa"
            showMask={false}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={handleBlur}
            mask={[
              /[1]/,
              /[3-4]/,
              /\d/,
              /\d/,
              '/',
              /[0-1]/,
              /[0-9]/,
              '/',
              /[0-3]/,
              /[0-9]/
            ]}
          />
        </DatetimePickerTrigger>

        <input
          type="text"
          className="hidden"
          value={!cleared && _moment ? _moment.format('YYYY-MM-DD') : ''}
          name={name}
          onChange={onChange}
          ref={value => {
            this.node = value
          }}
        />
      </div>
    )
  }
}
export default DatePicker
